export default function PHP_ip2long() {
  return (
    <div>
      <h1>PHP_ip2long</h1>
    </div>
  );
}
